module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-kpito-bottom-01.2.97591add.jpg";